import { Component } from '@angular/core';

@Component({
    selector: 'report-header',
    templateUrl: './report-header.component.html',
    styleUrls: ['./report-header.component.scss'],
    standalone: false
})
export class ReportHeaderComponent {}
